export default __webpack_public_path__ + "static/warehouse-89b57ed105d2f4a8bc86be1efc29f5f0.png";